import * as announcementsApi from '@/api/announcements/announcements'

const announcements = {
  state: {
  },
  mutations: {
  },
  actions: {
    getAnnouncements ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.getAnnouncements(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    showAnnouncement ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.showAnnouncement(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    storeAnnouncement ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.storeAnnouncement(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    updateAnnouncement ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.updateAnnouncement(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    destroyAnnouncement ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.destroyAnnouncement(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    uploadImageCompressed ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.uploadImageCompressed(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    uploadVideoCompressed ({ commit }, data) {
      return new Promise((resolve, reject) => {
        announcementsApi.uploadVideoCompressed(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
  }
}

export default announcements
